<section class="contact-strip">
  <div class="layout-fluid-constrained layout-align-center wrap">
    <div class="contact-item">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
        <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.3 0 .7-.2 1l-2.3 2.2z"></path>
      </svg>
      <div>
        <div class="label">Свържете се с нас</div>
        <div class="value"><a href="tel:070010076">0700 100 76</a></div>
      </div>
    </div>
    <div class="contact-item">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"></path>
      </svg>
      <div>
        <div class="label">E-mail</div>
        <div class="value"><a href="mailto:info@minizaem.bg">info@minizaem.bg</a></div>
      </div>
    </div>
  </div>
</section>

<div class="layout-fluid-constrained layout-align-center">
  <div class="info-sections">
    <div class="info-section work-time">
      <h3 class="name">Работно време</h3>
      <div class="text">
        <p>Понеделник – Петък</p>
        <p>от 8.30 до 17.30 часа</p>
        <p>Събота и Неделя - почивни дни</p>
      </div>
    </div>
    <div class="info-section useful-links">
      <h3 class="name">Полезно</h3>
      <ul>
        <li><a href="/page/about-us">За нас</a></li>
        <li><a href="/page/faq">Често задавани въпроси</a></li>
        <li><a href="/page/why-us">Защо minizaem.bg</a></li>
        <li><a href="/page/loan-terms">Общи условия за заемите</a></li>
        <li><a href="/page/website-terms">Общи условия на сайта</a></li>
        <li><a href="/page/data-protection-notice">Защита лични данни</a></li>
      </ul>
    </div>
    <div class="info-section">
      <h3 class="name">Новини</h3>
      <div class="news-wrapper">
        @if (newsListWrapper) {
          @for (news of newsListWrapper.newsList; track $index) {
            @if ($index < 2) {
              <div class="news-list-item">
                <div class="info-wrapper">
                  <a routerLink="/news/{{getTranslation(news)?.slug}}" class="name">{{ getTranslation(news)?.name }}</a>
                  <div class="date-wrapper">{{ news?.date | date: 'dd.MM.yyyy' }}</div>
                  <div class="text" [innerHTML]="getTranslation(news)?.text.slice(0,200) "></div>
                </div>
              </div>
            }
          }
        } @else {
          <p>Няма намерени новини.</p>
        }
      </div>
    </div>
  </div>
</div>
